import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser } from "@utils";

export const tenantApi = createApi({
	reducerPath: "tenantApi",
	refetchOnFocus: true,
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["tenant-api"],
		prepareHeaders: (headers) => {
			const user = getUser();

			if (user?.token) {
				headers.set("Authorization", `Bearer=${user.token}`);
			}

			return headers;
		},
	}),
	endpoints: (builder) => ({
		getTenantStatistics: builder.query({
			query: (params) => ({
				url: "statistics",
				method: "GET",
				params,
			}),
			providesTags: ["Statistics"],
		}),
	}),
});

export const { useGetTenantStatisticsQuery } = tenantApi;
